<template>
  <div class="car-type">
    <div class="car-type__purpose">
      <!-- 标题区域 -->
      <div class="car-type__title">
        <div class="car-type__heading">Browse by Purpose</div>
        <a :href="allCarsLink" class="car-type__view">
          <div class="car-type__view-all">View All</div>
          <img src="@/assets/view-all.svg" class="car-type__icon" alt="">
        </a>
      </div>

      <!-- 类型卡片区域：PC横向，移动端纵向 -->
      <div class="car-type__cards" :class="{'car-type__cards--mobile': deviceType === 'mobile'}">
        <a v-for="(type, index) in carTypes" :key="`type-${index}`" class="car-type__card"
          :href="getPurposeLink(type.value)">
          <div class="car-type__card-icon">
            <img :src="type.icon" class="car-type__icon-img" alt="">
          </div>
          <div class="car-type__card-name">{{ type.name }}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import navigationMixin from '@/mixin/navigationMixin.js';

export default {
  name: 'CarType',
  mixins: [navigationMixin],
  computed: {
    ...mapGetters({
      deviceType: 'deviceType'
    }),
    allCarsLink () {
      return this.getCarListUrl(this.$route.query);
    }
  },
  data () {
    return {
      carTypes: [
        {
          name: 'Family Car',
          value: 'Family Vehicle',
          icon: require('../assets/type/family_car.png')
        },
        {
          name: 'Commercial Vehicle',
          value: 'Commercial Vehicle',
          icon: require('@/assets/type/commercial_vehicle.png')
        },
        {
          name: 'Cross Country Vehicle',
          value: 'Cross Country Vehicle',
          icon: require('@/assets/type/offroad_vehicle.png')
        },
        {
          name: 'Sports Car',
          value: 'Sport Vehicle',
          icon: require('@/assets/type/sports_car.png')
        }
      ]
    }
  },
  methods: {
    getPurposeLink (purpose) {
      if (!purpose) {
        return '#';
      }
      const query = { ...this.$route.query, purpose };
      return this.getCarListUrl(query);
    }
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.car-type {
	padding: rem(50) rem(120);
	display: flex;
	flex-direction: column;
	gap: rem(10);
	align-items: center;
	justify-content: center;
	align-self: stretch;
	position: relative;

	&__purpose {
		display: flex;
		flex-direction: column;
		gap: rem(20);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		width: 100%;
	}

	&__title {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		position: relative;
	}

	&__heading {
		color: #050b20;
		text-align: left;
		font-size: rem(24);
		line-height: rem(24);
		font-weight: 900;
		position: relative;
	}

	&__view {
		display: flex;
		align-items: center;
		gap: rem(10);
		cursor: pointer;
	}

	&__view-all {
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 500;
		color: #405ff2;
	}

	&__icon {
		flex-shrink: 0;
		width: rem(14);
		height: rem(14);
		position: relative;
		overflow: visible;
	}

	&__cards {
		display: flex;
		flex-direction: row;
		gap: rem(20);
		align-items: stretch;
		justify-content: space-between;
		align-self: stretch;
		position: relative;

		// 移动端样式 - 纵向排列
		&--mobile {
			flex-direction: column;
			gap: rem(16);
		}
	}

	&__card {
		background: #ffffff;
		border-radius: rem(12);
		border: 1px solid #e9e9e9;
		padding: rem(30) rem(20);
		display: flex;
		flex-direction: column;
		gap: rem(4);
		align-items: center;
		justify-content: center;
		flex: 1;
		position: relative;
		transition: all 0.3s ease;
		cursor: pointer;

		&:hover {
			box-shadow: 0 rem(4) rem(12) rgba(0, 0, 0, 0.08);
			border-color: #d0d0d0;
		}
	}

	&__card-icon {
		width: rem(200);
		height: rem(120);
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
	}

	&__icon-img {
		width: 100%;
		height: 100%;
		object-fit: contain;
		position: relative;
	}

	&__card-name {
		color: #050b20;
		text-align: center;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 400;
		position: relative;
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.car-type {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	.car-type {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);
		padding: rem(30) rem(16);

		&__purpose {
			width: 100%;
		}

		&__view-all {
			font-size: rem(14);
			line-height: rem(14);
		}
		&__icon {
			width: rem(14);
			height: rem(14);
		}

		&__card {
			padding: rem(20) rem(16);
		}

		// &__card-icon {
		// 	width: rem(56);
		// 	height: rem(56);
		// }

		// &__icon-img {
		// 	width: rem(28);
		// 	height: rem(28);
		// }

		&__card-name {
			font-size: rem(14);
			line-height: rem(14);
		}
	}
}
</style> 